/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {AppRoleLevel, TabPermissions} from "@app/app-shared/permission";
import {hasUserRole, hasUserTabPermissions} from "@modules/utils";

type Props = {
    appRoles: AppRoleLevel[]
    tabPermissions?: TabPermissions[]
    fallback?: React.ReactNode
    children: React.ReactNode
}

export function AppPermissions({appRoles, children, fallback, tabPermissions}: Props) {
    const permitted = hasUserRole(appRoles) && hasUserTabPermissions(tabPermissions);
    if (permitted)
        return children;

    if (fallback)
        return fallback

    return null;
}
